// src/pages/support/components/ChangeCaptainForm.jsx
import React, { useState } from "react";
import Field from "./Field";

function ChangeCaptainForm({ team, onSubmit }) {
  const members = Array.isArray(team?.members) ? team.members : [];
  const memberOptions = members.map((m) => ({
    id: m.user_id,
    label: m?.user?.username || m?.user?.email || `کاربر ${m.user_id}`,
  }));

  const [newCaptainId, setNewCaptainId] = useState(
    memberOptions[0]?.id || team?.captain_user_id || ""
  );
  const [reason, setReason] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [err, setErr] = useState("");

  function validate() {
    if (!newCaptainId) return "انتخاب کاپیتان جدید الزامی است.";
    return "";
  }

  async function handleSubmit(e) {
    e.preventDefault();
    const v = validate();
    if (v) return setErr(v);
    setErr("");
    setSubmitting(true);
    try {
      await onSubmit(
        {
          new_captain_user_id: Number(newCaptainId),
          reason: reason?.trim() || "Change captain via admin panel",
        },
        () => setSubmitting(false),
        (msg) => {
          setSubmitting(false);
          setErr(msg);
        }
      );
    } catch (e) {
      setSubmitting(false);
      setErr(e.message || "خطای نامشخص");
    }
  }

  return (
    <form onSubmit={handleSubmit} className="space-y-4 text-right">
      {err && <div className="text-red-400 text-sm">{err}</div>}

      <Field label="انتخاب کاپیتان جدید از میان اعضای تیم">
        <select
          value={newCaptainId}
          onChange={(e) => setNewCaptainId(e.target.value)}
          className="w-full rounded-xl bg-gray-800 border border-gray-700 text-gray-200 px-3 py-2 focus:outline-none focus:border-emerald-500"
        >
          {memberOptions.length === 0 ? (
            <option value="">— عضوی وجود ندارد —</option>
          ) : (
            memberOptions.map((opt) => (
              <option key={opt.id} value={opt.id}>
                {opt.label} (ID: {opt.id})
              </option>
            ))
          )}
        </select>
      </Field>

      <Field label="دلیل تغییر (اختیاری)">
        <textarea
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          rows={3}
          className="w-full rounded-xl bg-gray-800 border border-gray-700 text-gray-200 px-3 py-2 focus:outline-none focus:border-emerald-500"
          placeholder="مثال: به‌علت فعالیت مستمر و رهبری بهتر"
        />
      </Field>

      <div className="flex justify-end gap-3 pt-2">
        <button
          type="submit"
          disabled={submitting || memberOptions.length === 0}
          className={`px-4 py-2 rounded-xl text-white ${submitting ? "opacity-70" : ""}`}
          style={{ backgroundColor: "#0ea5e9" }}
        >
          {submitting ? "در حال اعمال..." : "ثبت تغییر کاپیتان"}
        </button>
      </div>
    </form>
  );
}

export default ChangeCaptainForm;